export default theme => ({

  paper: {
    display: 'inline-block',
    width: theme.spacing.unit * 45,
    marginTop: '10vh'
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/auth.js